(function (module) {
    'use strict';
    module.directive('emSearchButton', function () {
        return {
            scope: {
                ngModel: '=',
                asForm: '@',
                onSubmit: '&'
            },
            templateUrl: 'directives/search-button/search-button.tpl.html',
            link: function (scope, element, attr) {
                element.parent().addClass('em-search-button-parent');
                var button = angular.element(element[0].querySelectorAll('.search-button-action'));
                button.on('click', function () {
                    scope.$apply(function () {
                        scope.ngModel = '';
                    });
                    element.find('md-toolbar').toggleClass('active');
                    element.find('input').focus();
                });
                scope.submitForm = function () {
                    element.find('md-toolbar').toggleClass('active');
                    scope.onSubmit();
                };
            }
        };
    });
}(angular.module('emarket.commons')));
